import { useState, useEffect } from 'react';
import JobRoleService from '../services/JobRoleService';
export const useJobRoles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [jobRoles, setJobRoles] = useState([]);
  useEffect(() => {
    JobRoleService.all().then(data => {
      setIsLoading(false);
      setJobRoles(data);
    }).catch(() => {
      setIsLoading(false);
      setJobRoles([]);
    });
  }, []);
  return {
    list: jobRoles,
    isLoading
  };
};